export default __webpack_public_path__ + "static/media/rs-redes-sociais.44614151.webp";